function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $09c0365e8da4e13e$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"fT3mu":"shopping-list.b02eb39d.js","cagbC":"amazon.14359d3c.png","hJuzG":"apple.9c33fe27.png","hDM3Y":"bookshop.8a4b449f.png","kvnZu":"books_mob_1x.7615c344.png","kpXdd":"index.77640218.js","49fu0":"index.f5174d27.js"}'));

parcelRequire("5xxQm");
parcelRequire("8FnLx");
parcelRequire("ciJSj");
parcelRequire("dTazW");

var $9bk7d = parcelRequire("9bk7d");
var $d18942ad4f41d8f9$exports = {};

$d18942ad4f41d8f9$exports = new URL((parcelRequire("kyEFX")).resolve("cagbC"), import.meta.url).toString();


var $5eb08976ad5d216c$exports = {};

$5eb08976ad5d216c$exports = new URL((parcelRequire("kyEFX")).resolve("hJuzG"), import.meta.url).toString();


var $5c136209abd86774$exports = {};

$5c136209abd86774$exports = new URL((parcelRequire("kyEFX")).resolve("hDM3Y"), import.meta.url).toString();


var $0ddc8e7b3976b3ac$exports = {};
$0ddc8e7b3976b3ac$exports = "<svg width=\"18\" height=\"18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.75 2.25h4.5m-9 2.25h13.5m-1.5 0-.526 7.89c-.079 1.183-.118 1.775-.374 2.224a2.25 2.25 0 0 1-.974.91c-.464.226-1.058.226-2.244.226H7.868c-1.186 0-1.78 0-2.244-.225a2.25 2.25 0 0 1-.974-.911c-.256-.449-.295-1.04-.374-2.225L3.75 4.5M7.5 7.875v3.75m3-3.75v3.75\" stroke=\"#fff\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>";


var $2f7f54bb4b8e1dd7$exports = {};

$2f7f54bb4b8e1dd7$exports = new URL((parcelRequire("kyEFX")).resolve("kvnZu"), import.meta.url).toString();



var $gjiCh = parcelRequire("gjiCh");
const $e5c62ffd1c5d842f$var$foundsList = document.querySelector(".sheave");
const $e5c62ffd1c5d842f$var$mainList = document.querySelector(".shopping-list-list");
const $e5c62ffd1c5d842f$var$screenWidth = window.screen.width;
if ($e5c62ffd1c5d842f$var$screenWidth < 1440) $e5c62ffd1c5d842f$var$foundsList.classList.add("visually-hidden");
$e5c62ffd1c5d842f$export$2c00f8075f82ed41();
function $e5c62ffd1c5d842f$export$2c00f8075f82ed41() {
    if ((0, $9bk7d.authStates).status === false) $e5c62ffd1c5d842f$var$mainList.innerHTML = "";
    (0, $gjiCh.showLoader)();
    (0, $9bk7d.readShoppingList)((0, $9bk7d.dataUser).userId).then((snapshot)=>{
        if (snapshot.exists()) {
            const shoppingList = snapshot.val();
            const keys = Object.keys(shoppingList);
            const books = [];
            if (keys.length !== 0) {
                for (let key of keys){
                    const book = shoppingList[`${key}`];
                    const bookMarkup = `<li class="shop-cart-container">
        <div class="shop-cart-wrap">
          <div class="shop-image-wrapper">
            <img class="shop-image" src="${book.book_image}" alt="${book.title}" width="100" height="142" />
          </div>
          <div class="shop-cart-info">
            <h2 class="shop-cart-title">${book.title}</h2>
            <h3 class="shop-cart-category">${book.list_name}</h3>
            <p class="shop-cart-description">${book.description}
            </p>
            <div class="shop-cart-bottom-wrap">
              <h4 class="shop-cart-author">${book.author}</h4>
              <ul class="shop-cart-media">
                <li class="shop-cart-media-item">
                  <a
                    href="${book.buy_links[0].url}"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Amazon"
                  >
                    <picture class="amazon-picture">
                      <source
                        srcset="${(0, (/*@__PURE__*/$parcel$interopDefault($d18942ad4f41d8f9$exports)))}"
                        type="image/png"
                      />
                      <img
                        class="media-icon amazon-icon"
                        src="${(0, (/*@__PURE__*/$parcel$interopDefault($d18942ad4f41d8f9$exports)))}"
                        alt="Amazon logo"
                        width="32"
                        height="11"
                      />
                    </picture>
                  </a>
                </li>
                <li class="shop-cart-media-item">
                  <a
                    href="${book.buy_links[1].url}"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Apple Books"
                  >
                    <picture>
                      <source
                        srcset="${(0, (/*@__PURE__*/$parcel$interopDefault($5eb08976ad5d216c$exports)))}"
                        type="image/png"
                      />
                      <img
                        class="media-icon media-book-icon"
                        src="${(0, (/*@__PURE__*/$parcel$interopDefault($5eb08976ad5d216c$exports)))}"
                        alt="Apple book logo"
                        width="16"
                        height="16"
                      />
                    </picture>
                  </a>
                </li>
                <li class="shop-cart-media-item">
                  <a
                    href="${book.buy_links[4].url}"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Bookshop"
                  >
                    <picture>
                      <source
                        srcset="${(0, (/*@__PURE__*/$parcel$interopDefault($5c136209abd86774$exports)))}"
                        type="image/png"
                      />
                      <img
                        class="media-icon media-book-icon"
                        src="${(0, (/*@__PURE__*/$parcel$interopDefault($5c136209abd86774$exports)))}"
                        alt="Book shop logo"
                        width="16"
                        height="16"
                      />
                    </picture>
                  </a>
                </li>
              </ul>
            </div>
            <button
              class="shop-cart-btn"
              type="button"
              id="${key}"
              data-title="title"
              aria-label="Remove button"
            >
           <svg class="shop-cart-btn-trash" width="18" height="18" id="${key}">
           ${(0, (/*@__PURE__*/$parcel$interopDefault($0ddc8e7b3976b3ac$exports)))}
           </svg>
            </button>
          </div>
        </div>
      </li>`;
                    books.push(bookMarkup);
                }
                const markupList = books.join("");
                $e5c62ffd1c5d842f$var$mainList.innerHTML = markupList;
                const shopList = document.querySelector(".shopping-list-list");
                shopList.addEventListener("click", $e5c62ffd1c5d842f$var$removeCardInShopList);
            }
        } else {
            const titleNoneMarkup = `<li><p class="empty-shopping-list-text">
      This page is empty, add some books and proceed to order.
    </p>
     
      <picture>
        <sorce
          srset="${(0, (/*@__PURE__*/$parcel$interopDefault($2f7f54bb4b8e1dd7$exports)))}"
          type="image/png"
        />
        <img
          class="empty-shopping-list-img"
          src="${(0, (/*@__PURE__*/$parcel$interopDefault($2f7f54bb4b8e1dd7$exports)))}"
          alt="empty shopping list img"
        />
      </picture>
        </li>`;
            $e5c62ffd1c5d842f$var$mainList.innerHTML = titleNoneMarkup;
        }
        (0, $gjiCh.hideLoader)();
    });
}
function $e5c62ffd1c5d842f$var$removeCardInShopList(event) {
    // if (event.target.nodeName !== 'BUTTON') {
    if (event.target.nodeName !== "BUTTON" && event.target.nodeName !== "svg") return;
    const bookItemId = event.target.id;
    (0, $9bk7d.removeElShoppingList)((0, $9bk7d.dataUser).userId, bookItemId);
    $e5c62ffd1c5d842f$export$2c00f8075f82ed41();
}


parcelRequire("6zeq2");
parcelRequire("bUb57");
parcelRequire("gjiCh");
parcelRequire("9tydV");


//# sourceMappingURL=shopping-list.b02eb39d.js.map
